<div class="container-fluid top-nav pt-3">
    <div class="row" *ngIf="hubspotintegration">
        <div class="col-12 col-md">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-auto">
                            <app-customerlogo [enableChange]="true"
                                [customerId]="modalCustomer.customerId"></app-customerlogo>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <p class="mb-0 fw-400 pb-2">{{modalCustomer.title}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p class="mb-0 fw-400 pb-2">Type: {{modalCustomer.customerType}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p class="mb-0 pb-1">{{modalCustomer.address1}}</p>
                                    <p class="mb-0 pb-1">{{modalCustomer.address2}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p class="mb-0 pb-1">{{modalCustomer.city}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <p class="mb-0 pb-1">{{modalCustomer.zip}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-auto pr-0">
                                            <a class="cursor-pointer" href="{{modalCustomer.website}}" target="_blank">
                                                <span
                                                    class="material-icons f-20 opacity lh-30 align-middle cursor-pointer text-muted">
                                                    public
                                                </span>
                                            </a>
                                        </div>
                                        <div class="col-auto pl-1">
                                            <a class="cursor-pointer" href="{{modalCustomer.website}}" target="_blank">
                                                <p class="mb-0 pt-1 cursor-pointer opacity">{{modalCustomer.website}}
                                                </p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-auto pr-0">
                                            <span
                                                class="material-icons f-20 lh-30 align-middle cursor-default text-muted">
                                                account_circle
                                            </span>
                                        </div>
                                        <div class="col-auto pl-1">
                                            <p class="mb-0 cursor-default pt-1">{{modalCustomer.main_contact}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2 ">
                        <div class="col">
                            <p class="mb-0 text-dark cursor-pointer"><quill-view-html class="quill-no-pad text-dark"
                                    [content]="modalCustomer.description" theme="snow"></quill-view-html></p>
                            <!-- <p class="mb-0">{{modalCustomer.description}}</p> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3 mb-3">
                <div class="card-body">
                    <div class="pr-3">
                        <div class="row">
                            <div class="col text-center">
                                <!-- <a class="cursor-pointer"  data-toggle="modal" data-target="#assignTags">
                                <span matTooltip="Tag customer" matTooltipPosition="left" matTooltipShowDelay="500" 
                                    class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                    label 
                                </span>
                                <p class="mb-0 pt-1 text-center f-13">Tags</p>
                            </a> -->
                                <app-tagaddremove [entityId]="modalCustomer.customerId"
                                    [tagtype]="'customer'"></app-tagaddremove>
                            </div>
                            <div class="col text-center">
                                <!--- connect to management modal --->
                                <a class="cursor-pointer" (click)="showCustomerView()">
                                    <span matTooltip="{{ 'customerpage.viewtip' | trans }}" matTooltipPosition="left"
                                        matTooltipShowDelay="500"
                                        class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                        preview
                                    </span>
                                    <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.view' | trans }}</p>
                                </a>
                            </div>
                            <div class="col d-none d-sm-block text-center">
                                <!--- connect to management modal --->
                                <a class="cursor-pointer" data-toggle="modal" data-target="#customerwelcomemodal">
                                    <span matTooltip="{{ 'customerpage.customerwelcometip' | trans }}"
                                        matTooltipPosition="left" matTooltipShowDelay="500"
                                        class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                        handshake
                                    </span>
                                    <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.customerwelcome' | trans }}
                                    </p>
                                </a>
                            </div>
                            <div class="col text-center">
                                <a class="cursor-pointer" data-toggle="modal" data-target="#customerdeleteModal">
                                    <span matTooltip="{{ 'customerpage.deletetip' | trans }}" matTooltipPosition="left"
                                        matTooltipShowDelay="500"
                                        class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                        delete
                                    </span>
                                    <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.delete' | trans }}</p>
                                </a>
                            </div>
                            <div class="col d-none d-sm-block text-center">
                                <a data-toggle="modal" data-target="#imageeditModal" class="cursor-pointer">
                                    <span matTooltip="{{ 'customerpage.logotip' | trans }}" matTooltipPosition="left"
                                        matTooltipShowDelay="500"
                                        class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                        perm_media
                                    </span>
                                    <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.logo' | trans }}</p>
                                </a>
                            </div>
                            <div class="col text-center">
                                <a data-toggle="modal" data-target="#infoeditModal" class="cursor-pointer">
                                    <span matTooltip="{{ 'customerpage.edittip' | trans }}" matTooltipPosition="left"
                                        matTooltipShowDelay="500"
                                        class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                        create
                                    </span>
                                    <p class="mb-0 text-center pt-1 f-13">{{ 'customerpage.edit' | trans }}</p>

                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 mb-3">
            <app-customerdeallist *ngIf="hubspotintegration"> </app-customerdeallist>
        </div>
    </div>
    <div class="card p-3 mb-3" *ngIf="!hubspotintegration">
        <div class="row">
            <div class="col-auto">
                <app-customerlogo [enableChange]="true" [customerId]="modalCustomer.customerId"></app-customerlogo>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <p class="mb-0 fw-400 pb-2">{{modalCustomer.title}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 fw-400 pb-2">Type: {{modalCustomer.customerType}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 pb-1">{{modalCustomer.address1}}</p>
                        <p class="mb-0 pb-1">{{modalCustomer.address2}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 pb-1">{{modalCustomer.city}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <p class="mb-0 pb-1">{{modalCustomer.zip}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col-auto pr-0">
                                <a class="cursor-pointer" href="{{modalCustomer.website}}">
                                    <span
                                        class="material-icons f-20 opacity lh-30 align-middle cursor-pointer text-muted">
                                        public
                                    </span>
                                </a>
                            </div>
                            <div class="col-auto pl-1">
                                <a class="cursor-pointer" href="{{modalCustomer.website}}">
                                    <p class="mb-0 pt-1 cursor-pointer opacity">{{modalCustomer.website}}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col-auto pr-0">
                                <span class="material-icons f-20 lh-30 align-middle cursor-default text-muted">
                                    account_circle
                                </span>
                            </div>
                            <div class="col-auto pl-1">
                                <p class="mb-0 cursor-default pt-1">{{modalCustomer.main_contact}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="float-right pr-3">
                    <div class="row">
                        <div class="col text-center">
                            <!-- <a class="cursor-pointer"  data-toggle="modal" data-target="#assignTags">
                                <span matTooltip="Tag customer" matTooltipPosition="left" matTooltipShowDelay="500" 
                                    class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                    label 
                                </span>
                                <p class="mb-0 pt-1 text-center f-13">Tags</p>
                            </a> -->
                            <app-tagaddremove [entityId]="modalCustomer.customerId"
                                [tagtype]="'customer'"></app-tagaddremove>
                        </div>
                        <div class="col text-center">
                            <!--- connect to management modal --->
                            <a class="cursor-pointer" (click)="showCustomerView()">
                                <span matTooltip="{{ 'customerpage.viewtip' | trans }}" matTooltipPosition="left"
                                    matTooltipShowDelay="500"
                                    class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                    preview
                                </span>
                                <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.view' | trans }}</p>
                            </a>
                        </div>
                        <div class="col text-center">
                            <!--- connect to management modal --->
                            <a class="cursor-pointer" data-toggle="modal" data-target="#customerwelcomemodal">
                                <span matTooltip="{{ 'customerpage.introtip' | trans }}" matTooltipPosition="left"
                                    matTooltipShowDelay="500"
                                    class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                    dashboard_customize
                                </span>
                                <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.intro' | trans }}</p>
                            </a>
                        </div>
                        <div class="col text-center">
                            <a class="cursor-pointer" data-toggle="modal" data-target="#customerdeleteModal">
                                <span matTooltip="{{ 'customerpage.deletetip' | trans }}" matTooltipPosition="left"
                                    matTooltipShowDelay="500"
                                    class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                    delete
                                </span>
                                <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.delete' | trans }}</p>
                            </a>
                        </div>
                        <div class="col text-center">
                            <a data-toggle="modal" data-target="#imageeditModal" class="cursor-pointer">
                                <span matTooltip="{{ 'customerpage.logotip' | trans }}" matTooltipPosition="left"
                                    matTooltipShowDelay="500"
                                    class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                    perm_media
                                </span>
                                <p class="mb-0 pt-1 text-center f-13">{{ 'customerpage.logo' | trans }}</p>
                            </a>
                        </div>
                        <div class="col text-center">
                            <a data-toggle="modal" data-target="#infoeditModal" class="cursor-pointer">
                                <span matTooltip="{{ 'customerpage.edittip' | trans }}" matTooltipPosition="left"
                                    matTooltipShowDelay="500"
                                    class="material-icons bg-lightgrey f-20 opacity text-center center rounded-circle p-2 text-muted cursor-pointer">
                                    create
                                </span>
                                <p class="mb-0 text-center pt-1 f-13">{{ 'customerpage.edit' | trans }}</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2 ">
            <div class="col">
                <p class="mb-0 text-dark cursor-pointer"><quill-view-html class="quill-no-pad text-dark"
                        [content]="modalCustomer.description" theme="snow"></quill-view-html></p>
                <!-- <p class="mb-0">{{modalCustomer.description}}</p> -->
            </div>
        </div>
    </div>
    <div class="row mt-3 mt-md-0">
        <div class="col-12 col-sm-12 col-md-6">
            <div class="card p-3">
                <div class="mb-2 mb-md-0"></div>
                <app-customeruserlist [customer]="modalCustomer" [userToAdd]="userToAdd"></app-customeruserlist>
                <app-customerusercreate [customer]="modalCustomer" [light]="true"
                    (userToAdd)="addNewUserToList($event)"></app-customerusercreate>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
            <div class="card mt-3 mt-md-0 p-3">
                <a class="cursor-pointer" *ngIf="projecttoggler"
                    matTooltip="{{ 'customerpage.showcustomerprojects' | trans }}" matTooltipPosition="above"
                    matTooltipShowDelay="500" style="position: absolute; right: 10px; top:10px; z-index:1;"
                    (click)="toggleprojects()">
                    <span
                        class="material-icons f-20 opacity lh-30 w-30 text-center align-middle rounded-circle cursor-pointer bg-lightgrey text-muted">
                        view_list
                    </span>
                </a>
                <a class="cursor-pointer" *ngIf="!projecttoggler"
                    matTooltip="{{ 'customerpage.showcustomerfiles' | trans }}" matTooltipPosition="above"
                    matTooltipShowDelay="500" style="position: absolute; right: 10px; top:10px; z-index:1;"
                    (click)="toggleprojects()">
                    <span
                        class="material-icons f-20 opacity lh-30 w-30 text-center align-middle rounded-circle cursor-pointer bg-lightgrey text-muted">
                        inventory
                    </span>
                </a>
                <div *ngIf="projecttoggler" class=""><app-filelist [modal]="false" [list]="true"
                        [filetype]="'org-customer'" [entityid]="modalCustomer.customerId"></app-filelist></div>
                <app-customerprojectlist *ngIf="!projecttoggler" [customer]="modalCustomer"></app-customerprojectlist>
            </div>
        </div>
    </div>
    <div class="spacer"></div>
</div>





<!-- Modal Customer welcome customize -->
<div class="modal fade" id="customerwelcomemodal" tabindex="-1" role="dialog"
    aria-labelledby="customer welcome control">
    <app-customerwelcomeedit [isTemplate]="false" [customerId]="customerId"
        [customerspec]="true"></app-customerwelcomeedit>

</div>
<!-- information edit Modal -->
<div class="modal fade" id="infoeditModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'customerpage.editcustomerinformation' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">{{ 'customerpage.customertitle' | trans }}</p>
                        <input type="text" class="rounded bg-lightgrey border-0 w-100 fw-400 f-16 p-2" name="title"
                            [(ngModel)]="modalCustomer.title">
                    </div>
                </div>

                <div class="form-group mb-1">
                    <label class="f-13 font-weight-light mb-0 text-muted" for="signupDescription">{{
                        'customerpage.description' | trans }}</label>
                    <quill-editor [modules]="modules" id="signupDescription" class="w-100 toolontop" name="description"
                        [(ngModel)]="modalCustomer.description">
                        <p>{{ 'customerpage.descriptionplace' | trans }}</p>
                    </quill-editor>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">{{ 'customerpage.customerType' | trans }}</p>
                        <select class="rounded bg-lightgrey border-0 w-100 p-2" name="customerType"
                            [(ngModel)]="modalCustomer.customerType">
                            <option value="normal">Normal</option>
                            <option value="light">Light</option>
                        </select>
                    </div>
                </div>


                <div class="row mt-2">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">{{ 'customerpage.address' | trans }}</p>
                        <input type="text" class="rounded bg-lightgrey border-0 w-100 p-2" name="address1"
                            [(ngModel)]="modalCustomer.address1">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">{{ 'customerpage.address2' | trans }}</p>
                        <input type="text" class="rounded bg-lightgrey border-0 w-100 p-2" name="address2"
                            [(ngModel)]="modalCustomer.address2">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">{{ 'customerpage.city' | trans }}</p>
                        <input type="text" class="rounded bg-lightgrey border-0 w-100 p-2" name="city"
                            [(ngModel)]="modalCustomer.city">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">{{ 'customerpage.website' | trans }}</p>
                        <input type="text" class="rounded bg-lightgrey border-0 w-100 p-2" name="zip"
                            [(ngModel)]="modalCustomer.website">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">{{ 'customerpage.zip' | trans }}</p>
                        <input type="text" class="rounded bg-lightgrey border-0 w-100 p-2" name="zip"
                            [(ngModel)]="modalCustomer.zip">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <p class="mb-0 f-13 text-muted pl-1">CRM ID</p>
                        <input type="text" class="rounded bg-lightgrey border-0 w-100 p-2" name="zip"
                            [(ngModel)]="modalCustomer.customercrmId">
                    </div>
                </div>
                <!-- <div class="row pl-3 pr-3 mt-2">
                <p class="mb-0 f-13 text-muted pl-1">Description</p>
                <textarea                     
                type="text" 
                class="rounded bg-lightgrey w-100 border-0 p-1 pt-1 pb-1" 
                name="description" 
                [(ngModel)]="modalCustomer.description">
                </textarea>
            </div> -->
            </div>
            <div class="modal-footer">
                <button #closeeditmodal type="button" class="btn-close cursor-pointer" data-dismiss="modal">
                    <p class="btn-save-text">{{ 'customerpage.close' | trans }}</p>
                </button>
                <button (click)="onChange()" type="button" class="btn-save cursor-pointer" [disabled]="isSaving">
                    <p class="btn-save-text">{{ isSaving ? ('Saving...') : ('customerpage.savechanges' | trans) }}</p>
                </button>
            </div>
        </div>
    </div>
</div>
<!-- image edit Modal -->
<div class="modal fade" id="imageeditModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'customerpage.managecustomerimage' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-customerlogo [enableChange]="true" [customerId]="modalCustomer.customerId"></app-customerlogo>
            </div>

        </div>
    </div>
</div>
<!-- Modal DELETE CUSTOMER -->
<div class="modal fade" id="customerdeleteModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ 'customerpage.deletetip' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{ 'customerpage.deletemsg' | trans }}</p>
                <div class="alert alert-danger ml-0 mr-0" role="alert">
                    {{ 'customerpage.deletealert' | trans }}
                </div>
                <div class="row">
                    <div class="col">
                        <button type="button" class="btn-save" data-dismiss="modal">
                            <h6 class="btn-save-text">{{ 'customerpage.cancel' | trans }}</h6>
                        </button>
                    </div>
                    <div class="col">
                        <button (click)="onDelete()" type="button" class="btn-close" data-dismiss="modal">
                            <h6 class="btn-save-text">{{ 'customerpage.deletetip' | trans }}</h6>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





<!-- Modal assign tags-->
<div class="modal fade" id="assignTags" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">{{ 'customerpage.assigntags' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>{{ 'customerpage.assigntagshelp' | trans }}</p>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" placeholder="{{ 'customerpage.assigntagsplace' | trans }}"
                        aria-label="Recipient's username" aria-describedby="basic-addon2">
                    <div class="input-group-append h-35">
                        <button class="btn btn-outline-secondary" type="button">
                            <p class="btn-text">{{ 'customerpage.create' | trans }} </p>
                        </button>
                    </div>
                </div>
                <button class="btn pt-1 pl-2 pr-2 pb-1">
                    <p class="btn-text mb-0">{{ 'customerpage.tag1' | trans }}
                        <span class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
                            add
                        </span>
                    </p>
                </button>

                <div class="row border mt-3 mb-3 mr-0 ml-0 pl-2 pr-2"></div>

                <button class="btn pt-1 pl-2 pr-2 pb-1">
                    <p class="btn-text mb-0">{{ 'customerpage.tag1' | trans }}
                        <span class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
                            close
                        </span>
                    </p>
                </button>

            </div>
        </div>
    </div>
</div>